import { Link } from 'react-router-dom';

const SERVICE_LINKS = [
  { label: 'SEO',                     to: '/services' },
  { label: 'Social Media Marketing',  to: '/services' },
  { label: 'Performance Marketing',   to: '/services' },
  { label: 'Media Buying',            to: '/services' },
  { label: 'Paid Advertising',        to: '/services' },
  { label: 'Branding',                to: '/services' },
  { label: 'Website Development',     to: '/services' },
];

const COMPANY_LINKS = [
  { label: 'About Us',     to: '/about'      },
  { label: 'Our Process',  to: '/process'    },
  { label: 'Industries',   to: '/industries' },
  { label: 'Contact Us',   to: '/contact'    },
];

const SOCIALS = [
  { icon: 'ri-instagram-line',       href: '#', label: 'Instagram'  },
  { icon: 'ri-linkedin-box-line',    href: 'https://www.linkedin.com/company/blue-globe-media', label: 'LinkedIn'   },
  { icon: 'ri-twitter-x-line',       href: '#', label: 'Twitter/X'  },
  { icon: 'ri-facebook-circle-line', href: '#', label: 'Facebook'   },
];

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 pt-10 pb-6">
      <div className="max-w-site mx-auto px-4 sm:px-6">

        {/* Top */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 pb-8 border-b border-gray-200">

          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center mb-5 cursor-pointer group">
              <img
                src="/logo.webp"
                alt="Blue Globe Media"
                className="h-16 md:h-[4.5rem] w-auto max-w-[240px] md:max-w-[280px] object-contain object-left transition-transform duration-500 group-hover:scale-105"
              />
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed max-w-sm mb-7">
              A digital marketing agency helping businesses grow their online presence through focused strategy, honest execution, and measurable results.
            </p>
            <div className="flex items-center gap-3">
              {SOCIALS.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-gray-500 hover:text-brand-blue hover:border-brand-blue/30 hover:bg-brand-blue/5 transition-all duration-200 cursor-pointer hover:scale-110 active:scale-95"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display font-semibold text-gray-900 text-sm mb-5">
              <a id="services-footer-link" href="/services">Services</a>
            </h4>
            <ul className="space-y-3">
              {SERVICE_LINKS.map(s => (
                <li key={s.label}>
                  <Link
                    to={s.to}
                    className="text-gray-600 hover:text-gray-900 text-sm transition-colors duration-200 cursor-pointer hover:translate-x-1 inline-block"
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-display font-semibold text-gray-900 text-sm mb-5">Company</h4>
            <ul className="space-y-3">
              {COMPANY_LINKS.map(c => (
                <li key={c.label}>
                  <Link
                    to={c.to}
                    className="text-gray-600 hover:text-gray-900 text-sm transition-colors duration-200 cursor-pointer hover:translate-x-1 inline-block"
                  >
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-7">
              <h4 className="font-display font-semibold text-gray-900 text-sm mb-3">Contact</h4>
              <a
                href="mailto:info@blueglobemedia.com"
                className="text-gray-600 hover:text-brand-blue text-sm transition-colors duration-200 cursor-pointer break-all"
              >
                info@blueglobemedia.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-7 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} Blue Globe Media. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-gray-700 text-xs transition-colors cursor-pointer">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-500 hover:text-gray-700 text-xs transition-colors cursor-pointer">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
